import { Stack, Box, Typography } from '@mui/material';

interface IntroVideoCardProps {
  title: string;
  imageSrc: string;
  onItemClicked: () => void;
}

export const IntroVideoCard = (props: IntroVideoCardProps) => {
  return (
    <Stack
      onClick={props.onItemClicked}
      sx={{
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 0,
          pb: '56.48%',
          borderRadius: 3,
          position: 'relative',
          boxShadow: 8,
          backgroundSize: 'contain',
          backgroundImage: `url(${props.imageSrc})`,
        }}
      />
      <Typography
        variant='body1'
        fontWeight={'500'}
        sx={{
          mt: 5,
        }}
      >
        {`1. ${props.title}`}
      </Typography>
    </Stack>
  );
};
